var map = {
	"./adriatic.jpg": 43191,
	"./amethyst.jpg": 33417,
	"./azure_blue.jpg": 81276,
	"./baghdad_brown.jpg": 91110,
	"./bitter_chocolate.jpg": 69277,
	"./black.jpg": 49619,
	"./bright_red.jpg": 68508,
	"./bright_white.jpg": 46722,
	"./candy_pink.jpg": 41482,
	"./china_white.jpg": 55565,
	"./citrine.jpg": 54658,
	"./claret.jpg": 25591,
	"./cobalt.jpg": 47353,
	"./cool_blue.jpg": 45192,
	"./cool_grey.jpg": 43297,
	"./dark_grey.jpg": 20168,
	"./ebony.jpg": 42537,
	"./emerald.jpg": 35822,
	"./factory_yellow.jpg": 6493,
	"./forest.jpg": 48519,
	"./fuschia_pink.jpg": 26008,
	"./harvest.jpg": 77513,
	"./hot_pink.jpg": 51152,
	"./ice_white.jpg": 23581,
	"./imperial_blue.jpg": 14168,
	"./lavendar.jpg": 99145,
	"./lockwood_green.jpg": 89526,
	"./mandarin.jpg": 5816,
	"./marrs_green.jpg": 29291,
	"./mid_green.jpg": 70584,
	"./mist.jpg": 17883,
	"./natural.jpg": 65989,
	"./new_blue.jpg": 91681,
	"./nubuck_brown.jpg": 5975,
	"./pale_grey.jpg": 36664,
	"./park_green.jpg": 52972,
	"./pistachio.jpg": 69798,
	"./powder_green.jpg": 90515,
	"./pristine_white.jpg": 98094,
	"./purple.jpg": 97966,
	"./racing_green.jpg": 58958,
	"./real_grey.jpg": 38080,
	"./royal_blue.jpg": 89836,
	"./sapphire.jpg": 98866,
	"./scarlet.jpg": 85712,
	"./smoke.jpg": 83813,
	"./sorbet_yellow.jpg": 48846,
	"./stone.jpg": 34065,
	"./tabriz_blue.jpg": 15769,
	"./turquoise.jpg": 50961,
	"./vellum_white.jpg": 25063,
	"./vermillion.jpg": 90857,
	"./white.jpg": 28245,
	"./white_frost.jpg": 9030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54531;